import { InformationCircle32 } from '@packages/themes/icons';
import { Dialog, DialogContent, MuiIconButton } from '@packages/shared';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ServiceLayer } from '@packages/modules/src/ServiceLayer';
import type { RatingResult } from '@packages/gql/generated/shopping/graphql';

/**
 * Info button and dialog with rating information
 */
export const RatingInfo = ({
  verifiedRatingsHintLayerId,
}: Pick<RatingResult, 'verifiedRatingsHintLayerId'>) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const { formatMessage } = useIntl();

  if (!verifiedRatingsHintLayerId || verifiedRatingsHintLayerId === '') {
    return null;
  }

  return (
    <>
      {dialogOpened && (
        <Dialog
          open={dialogOpened}
          title={formatMessage({
            id: 'ratingsHint.title',
            defaultMessage: 'Info',
          })}
          handleClose={() => setDialogOpened(false)}
          dialogContent={
            <DialogContent>
              <ServiceLayer serviceLayerId={verifiedRatingsHintLayerId} />
            </DialogContent>
          }
          displayTrackingProps={{
            category: 'dv-service-layer-raiting-info',
          }}
        />
      )}
      <MuiIconButton
        onClick={() => setDialogOpened(true)}
        size="small"
        aria-label={formatMessage({
          id: 'ratingsHint.label',
          defaultMessage: 'Hinweise zu Bewertungen',
        })}
      >
        <InformationCircle32 color="info" fontSize="small" />
      </MuiIconButton>
    </>
  );
};
